import React from "react";
import { Box } from "@mui/material";
import BeaconSearchText from "../../components/BeaconSearchText";
import { BeaconFilterButton } from "../../components/BeaconFilterButton";

const CardsViewActions: React.FC = () => {

  return (
    <Box sx={{ display: "flex", alignItems: "end" }}>
      <BeaconSearchText />
      <BeaconFilterButton />
    </Box>
  );
};

export default CardsViewActions;
